async function getCoordinatesMap() {
  const responsePromise = await fetch('/businessGoogleMap.json');

  const response = await responsePromise.json();

  return response.map(item => new google.maps.LatLng(item.lat, item.lng));
}

export default getCoordinatesMap;
